const KLAVIYO_API_KEY = 'XgCqQ3'; 
const LIST_ID = 'Y9Vnhy';
/* 
    public key, safe to expose
    access within Klaviyo app at account > settings > API keys
    custom bis based off this support thread: 
    https://community.klaviyo.com/integrations-39/custom-back-in-stock-form-shopify-925 

    BIS Implementation: https://developers.klaviyo.com/en/reference/create_client_back_in_stock_subscription
    Client Subscription Implementation: https://developers.klaviyo.com/en/reference/create_client_subscription
*/

if (!customElements.get('klaviyo-back-in-stock-form')) {
    class KlaviyoBISForm extends HTMLElement {
        constructor() {
          super();
        }
        
        connectedCallback() {
          const notify_button = document.querySelector('[data-variant-id]');
          const data_variant_id = notify_button.dataset.variantId;
          const select_dropdown = document.querySelector('[data-variant-selector]');          
          if (data_variant_id) select_dropdown.value = data_variant_id;
          

          this.addEventListener('submit', (e) => {
            e.preventDefault();
            this.email = this.querySelector('[data-email-field]')?.value;
            this.formContent = this.querySelector('[data-form-content');
            
            this.formContent.classList.add('loading', 'loader');
            this.postForm().then(() => {
              this.formContent.classList.remove('loading', 'loader');
            });
          });
        }

        postForm = async() => {
          this.variantId = this.querySelector('[data-variant-selector]').value;
          this.consentToMarketing = this.querySelector('[data-marketing-consent-field]').checked;

          const data = {
            'type': 'back-in-stock-subscription',
            'attributes': {
                'profile': {
                    'data': {
                        'type': 'profile',
                        'attributes': {
                            'email': `${this.email}`
                        }
                    }
                },
                "channels": ["EMAIL"],
            },
            'relationships': {
                'variant': {
                    'data': {
                        'type': 'catalog-variant',
                        'id': `$shopify:::$default:::${this.variantId}`
                    }
                }
            }
        };
          
          await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${KLAVIYO_API_KEY}`, {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: '2024-02-15',
            'content-type': 'application/json'
          },
          body: JSON.stringify({ data })
        }).then(res => {
          if (res.ok) {
            this.formContent.innerHTML = `<div class="block text-lg text-center font-semibold pb-10 text-primaryDark">Thanks! We'll let you know when this item is back in stock.</div>`;
          }
        }).catch((err) => {
          this.formContent.innerHTML = `<div class="block text-lg text-center font-semibold text-primaryDark">Unable to add this item to your restock list.</div>`;
          console.error(err);
        });

        if (this.consentToMarketing) {
          const data = {
            'type': 'subscription',
            'attributes': {
              'profile': {
                'data': {
                  'type': 'profile',
                  'attributes': {
                    'email': `${this.email}`
                  }
                }
              },
            },
            'relationships': {
              'list': {
                'data': {
                  'type': 'list',
                  'id': `${LIST_ID}`
                }
              }
            }
          };
    
          const options = {
            method: 'POST',
            headers: {
              accept: 'application/json',
              revision: '2024-10-15', 
              'content-type': 'application/json'
            },
            body: JSON.stringify({ data })
          };
          
          fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${KLAVIYO_API_KEY}`, options)
            .then(res => res.json())
            .then(res => console.info(res))
            .catch(err => console.error(err));
        }
      }
    }
  
    customElements.define('klaviyo-back-in-stock-form', KlaviyoBISForm);
  }